import React from 'react';
import { Home, Building2, Building, Castle } from 'lucide-react';

interface PropertyTypeToggleProps {
    selectedTypes: string[];
    onChange: (types: string[]) => void;
}

export const PropertyTypeToggle: React.FC<PropertyTypeToggleProps> = ({ selectedTypes, onChange }) => {
    const options = [
        { label: 'Villa', value: 'Villa', icon: Home },
        { label: 'Townhouse', value: 'Townhouse', icon: Building },
        { label: 'Apartment', value: 'Apartment', icon: Building2 }, // Building2 is more apartment-like usually
        { label: 'Penthouse', value: 'Penthouse', icon: Castle }, // Castle as placeholder for luxury/high
    ];

    const toggle = (value: string) => {
        if (selectedTypes.includes(value)) {
            onChange(selectedTypes.filter(t => t !== value));
        } else {
            onChange([...selectedTypes, value]);
        }
    };

    return (
        <div className="grid grid-cols-2 gap-2">
            {options.map((opt) => {
                const isSelected = selectedTypes.includes(opt.value);
                const Icon = opt.icon;
                return (
                    <button
                        key={opt.value}
                        onClick={() => toggle(opt.value)}
                        className={`
                            flex items-center justify-center gap-2 p-3 rounded-xl border text-sm font-medium transition-all
                            ${isSelected
                                ? 'bg-slate-900 border-slate-900 text-white shadow-md'
                                : 'bg-white border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50'}
                        `}
                    >
                        <Icon size={16} />
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
};
